/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import jwt_decode from "jwt-decode";
import con from "@/firebase/firebaseInit.ts";
import firebase from 'firebase';
import ls from "@/common/localStorage"

var FirebaseAuthApi = con.FirebaseAuthApi;
var EncryptedLoginURL = con.EncryptedLoginURL
var GetSocialAuthToken = con.GetSocialAuthToken
var customDomain = ls.getSessionValueByKey("CustomDomain");

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser (context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getFirebaseAuth(context, field){
    return new Promise((resolve, reject) => {
      const headers = {
          "content-type": "application/json"
      }
      let requestData = {
        "emailId": field.email,
        "password": String(field.password)
      }

      
       
      let LoginURL = ""
      if (customDomain) {
        LoginURL = "https://" + customDomain;
      }
      axios.post(FirebaseAuthApi, requestData, { headers: headers }).then((response) => {
        if(response.data.status == 0)
        {
          LoginURL += "/loginexternal?lt="
          axios.post(EncryptedLoginURL, {"email": field.email, "password": String(field.password)}, { headers: headers }).then((res) => {
            if(res.data.status == 0)
            {
              LoginURL += res.data.result
              resolve(LoginURL)
            }
            else
              resolve(null)
          }).catch((error) => { resolve(null) })
        }
        else
          resolve(null)
        
      }).catch((error) => { resolve(null) })
    })
  },
  refreshAuthToken(){
    return new Promise((resolve, reject) => {
      let refreshToken = ls.getSessionValueByKey("Session_RefreshToken")
      const headers = {
          "content-type": "application/json",
          'Authorization': `Bearer ${refreshToken}`,
      }
      
      axios.post(FirebaseAuthApi, {}, { headers: headers }).then((response) => {
        firebase.auth().signInWithCustomToken(response.data.customToken).then((res) => {
          let info = {          
            Session_AccessToken: response.data.accessToken,
            Session_RefreshToken: response.data.refreshToken
          };                
          ls.setSessionUserInfo(info);
          resolve({status:200, message:'Token Refreshed'})
        }).catch(err=>{ reject(err) })
      }).catch(err=>{ reject(err) })
    })
  },
  checFirebaseAuthLoginBK(context, field){
    return new Promise((resolve, reject) => {
      const headers = {
          "content-type": "application/json"
      }
      let requestData = {
        "emailId": field.email,
        "password": String(field.password)
      }
      axios.post(FirebaseAuthApi, requestData, { headers: headers }).then((response) => {
        //console.log("accessToken- ", response)
        if(response.data.status == 0 && response.data.customToken)
        {          
          firebase.auth().signInWithCustomToken(response.data.customToken).then((res) => {
            let userDetail = response.data.data
            let isLoggedIn = false;
            let role = null;
            if (userDetail.UserRoles) {
              let roles = [1, 2, 3, 4];
              for (let i = 0; i < userDetail.UserRoles.length; i++) {
                if (roles.indexOf(userDetail.UserRoles[i].RoleID) != -1) {
                  isLoggedIn = true;
                  role = userDetail.UserRoles[i].RoleID;
                }
              }
            }

            if (isLoggedIn) {
                let info = {
                  il: 1,
                  Session_Client_Id: userDetail.ClientId,
                  Name: userDetail.Name,
                  UserId: userDetail.UserId,
                  Email: userDetail.Email,
                  ProfilePictureURL: userDetail.ProfilePictureURL,
                  Role: role,
                  Session_AccessToken: response.data.customToken,
                  Session_RefreshToken: response.data.refreshToken
                };                
                ls.setSessionUserInfo(info);
                if (role == 1)
                  resolve({status:200, message:"Login Successful.", redirectTo: "/client/list"})
                else {
                  con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).get()
                    .then(function (clientDoc) {
                      if (clientDoc.exists) {
                        var CustomDomain = clientDoc.data().CustomDomain;
                        ls.setSessionUserInfo({ CustomDomain: CustomDomain });
                        //document.cookie = `AT=${response.data.accessToken}`;
                        document.cookie = `AT=${response.data.accessToken};domain=.e2m.live`;
                        resolve({status:200, message:"Login Successful.", redirectTo: "/event/list"})
                      }
                    });
                }
              } else {
                resolve({status:500, message:"Not allowed to login!"})
              }

          }).catch((error) => { resolve({status:500, message:"Something Went Wrong."}) })
        }
        else
        {
          resolve({status:500, message:"Email or Password Invalid!"})
        }        
        
      }).catch((error) => { resolve({status:500, message:"Something Went Wrong!"}) })
    })
  },
  LoginWithTokenBK(context, accessToken){
    return new Promise((resolve, reject) => {
        if(accessToken)
        {
          axios.post(GetSocialAuthToken, {token:accessToken}).then((response) => {         
            //console.log(response) 
            firebase.auth().signInWithCustomToken(response.data.customToken).then((res) => {
              let userDetail = response.data.data
              let isLoggedIn = false;
              let role = null;
              if (userDetail.UserRoles) {
                let roles = [1, 2, 3];
                for (let i = 0; i < userDetail.UserRoles.length; i++) {
                  if (roles.indexOf(userDetail.UserRoles[i].RoleID) != -1) {
                    isLoggedIn = true;
                    role = userDetail.UserRoles[i].RoleID;
                  }
                }
              }

              if (isLoggedIn) {
                  let info = {
                    il: 1,
                    Session_Client_Id: userDetail.ClientId,
                    Name: userDetail.Name,
                    UserId: userDetail.UserId,
                    Email: userDetail.Email,
                    ProfilePictureURL: userDetail.ProfilePictureURL,
                    Role: role,
                    Session_AccessToken: response.data.customToken,
                    Session_RefreshToken: response.data.refreshToken
                  };
                  ls.setSessionUserInfo(info);
                  if (role == 1)
                    resolve({status:200, message:"Login Successful.", redirectTo: "/client/list"})
                  else {
                    con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).get()
                      .then(function (clientDoc) {
                        if (clientDoc.exists) {
                          var CustomDomain = clientDoc.data().CustomDomain;
                          ls.setSessionUserInfo({ CustomDomain: CustomDomain });
                          //document.cookie = `AT=${response.data.accessToken}`;
                          document.cookie = `AT=${response.data.accessToken};domain=.e2m.live`;
                          resolve({status:200, message:"Login Successful.", redirectTo: "/event/list"})
                        }
                      });
                  }
                } else {
                  resolve({status:500, message:"Not allowed to login!"})
                }

            }).catch((error) => { resolve({status:500, message:"Something Went Wrong."}) })
          })
        }
        else
        {
          resolve({status:500, message:"Email or Password Invalid!"})
        }        
        
    })
  },
  firebaseSignInWithCustomToken(context, customToken){
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithCustomToken(customToken).then((res) => {
        firebase.auth().currentUser.getIdToken(true).then(idToken=>{  
          var decodedToken = jwt_decode(idToken);                                      
            let info = {
              il: 1,                  
              Session_AccessToken: idToken,
              LoginTime: new Date().getTime(),
              idTExp: decodedToken.exp
            };
            ls.setSessionUserInfo(info);
            //document.cookie = `AT=${idToken}`;
            document.cookie = `AT=${idToken};domain=.e2m.live;path=/`;
            resolve({status:200, message:"Authentication done"})
        }).catch((error) => { reject(error) })
      }).catch((error) => { reject(error) })
    })
  },
  checFirebaseAuthLogin(context, field){
    return new Promise((resolve, reject) => {
      const headers = {
          "content-type": "application/json"
      }
      let requestData = {
        "emailId": field.email,
        "password": String(field.password)
      }
      axios.post(FirebaseAuthApi, requestData, { headers: headers }).then((response) => {
        if(response.data.status == 0 && response.data.customToken)
        {            
            let userDetail = response.data.data
            let isLoggedIn = false;
            let role = null;
            if (userDetail.UserRoles) {
              let roles = [1, 2, 3, 4];
              for (let i = 0; i < userDetail.UserRoles.length; i++) {
                if (roles.indexOf(userDetail.UserRoles[i].RoleID) != -1) {
                  isLoggedIn = true;
                  role = userDetail.UserRoles[i].RoleID;
                }
              }
            }

            if (isLoggedIn) {
                let info = {
                  il: 1,
                  Session_Client_Id: userDetail.ClientId,
                  Name: userDetail.Name,
                  UserId: userDetail.UserId,
                  Email: userDetail.Email,
                  ProfilePictureURL: userDetail.ProfilePictureURL,
                  Role: role
                };                
                if (role == 1)
                  resolve({status:200, message:"Login Successful.", redirectTo: "/client/list", customToken:response.data.customToken, userDetail: userDetail, info:info})
                else {
                  con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).get()
                    .then(function (clientDoc) {
                      if (clientDoc.exists) {
                        con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).collection('Features').doc('PlanDetails').get().then(function(planDoc) {
                          let ClientPlan = planDoc.exists ? JSON.stringify(planDoc.data()) : null;
                          var CustomDomain = clientDoc.data().CustomDomain;
                          let ClientName = clientDoc.data().ClientName;
                          let ClientLogo = clientDoc.data().LoginAssets.logo;
                          ls.setSessionUserInfo({ CustomDomain: CustomDomain, ClientPlan: ClientPlan, ClientName: ClientName, ClientLogo: ClientLogo });                          
                          resolve({status:200, message:"Login Successful.", redirectTo: "/event/list", customToken:response.data.customToken, userDetail: userDetail,info:info, userEvents: response.data.userEvents})
                        })
                      }
                    });
                }
              } else {
                resolve({status:500, message:"Not allowed to login!"})
              }
        }
        else
        {
          resolve({status:500, message:"Email or Password Invalid!"})
        }        
        
      }).catch((error) => { resolve({status:500, message:"Something Went Wrong!"}) })
    })
  },
  LoginWithToken(context, field){
    return new Promise((resolve, reject) => {
        if(field.token)
        {
          axios.post(GetSocialAuthToken, field).then((response) => {         
            //console.log(response) 
            firebase.auth().signInWithCustomToken(response.data.customToken).then((res) => {
              firebase.auth().currentUser.getIdToken(true).then(idToken=>{
              var decodedToken = jwt_decode(idToken);
              let userDetail = response.data.data
              let isLoggedIn = false;
              let role = null;
              if (userDetail.UserRoles) {
                let roles = [1, 2, 3];
                for (let i = 0; i < userDetail.UserRoles.length; i++) {
                  if (roles.indexOf(userDetail.UserRoles[i].RoleID) != -1) {
                    isLoggedIn = true;
                    role = userDetail.UserRoles[i].RoleID;
                  }
                }
              }

              if (isLoggedIn) {
                  let info = {
                    il: 1,
                    Session_Client_Id: userDetail.ClientId,
                    Name: userDetail.Name,
                    UserId: userDetail.UserId,
                    Email: userDetail.Email,
                    ProfilePictureURL: userDetail.ProfilePictureURL,
                    Role: role,
                    Session_AccessToken: idToken,
                    LoginTime: new Date().getTime(),
                    idTExp: decodedToken.exp
                    //Session_AccessToken: response.data.accessToken,
                    //Session_RefreshToken: response.data.refreshToken
                  };
                  ls.setSessionUserInfo(info);
                  if (role == 1)
                    resolve({status:200, message:"Login Successful.", redirectTo: "/client/list"})
                  else {
                    con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).get()
                      .then(function (clientDoc) {
                        if (clientDoc.exists) {
                          con.instanceDB.doc("ClientList").collection("Clients").doc(userDetail.ClientId).collection('Features').doc('PlanDetails').get().then(function(planDoc) {
                            let ClientPlan = planDoc.exists ? JSON.stringify(planDoc.data()) : null;
                            var CustomDomain = clientDoc.data().CustomDomain;
                            let ClientName = clientDoc.data().ClientName;
                            let ClientLogo = clientDoc.data().LoginAssets.logo;
                            ls.setSessionUserInfo({ CustomDomain: CustomDomain, ClientPlan: ClientPlan, ClientName: ClientName, ClientLogo: ClientLogo });
                            //document.cookie = `AT=${response.data.accessToken}`;
                            document.cookie = `AT=${idToken};domain=.e2m.live;path=/`;
                            resolve({status:200, message:"Login Successful.", redirectTo: "/event/list"})
                          })
                        }
                      });
                  }
                } else {
                  resolve({status:500, message:"Not allowed to login!"})
                }

            }).catch((error) => { resolve({status:500, message:"Something Went Wrong."}) })
            }).catch((error) => { reject(error) })
          }).catch((error) => { reject(error) })
        }
        else
        {
          resolve({status:500, message:"Email or Password Invalid!"})
        }        
        
    })
  },
  checkTokenExpiry({ commit }){
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          firebase.auth().currentUser.getIdToken(true).then(idToken=>{
            var decodedToken = jwt_decode(idToken);
            ls.setSessionUserInfo({Session_AccessToken: idToken, idTExp: decodedToken.exp});
            document.cookie = `AT=${idToken};domain=.e2m.live;path=/`;
            resolve(idToken)
          }).catch(err=>{
              firebase.auth().signOut().then(() => {
                ls.sessionLogOut();
                location.href="/pages/login";
                //this.$router.push('/pages/login');
              })
          })
        }
        else
        {
          firebase.auth().signOut().then(() => {
            ls.sessionLogOut();
            location.href="/pages/login";
            //this.$router.push('/pages/login');
          })
        }
      })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
